<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex">
        <h2 class="d-inline-flex my-auto">
          {{ title }}
        </h2>

        <v-spacer />

        <div class="d-inline-flex my-auto">
          <v-btn
            :disabled="!hasPrev"
            class="mx-1 brand-primary lighten-5"
            color="brand-primary"
            icon
            @click="onAffixClick('prev')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-btn
            :disabled="!hasNext"
            class="mx-1 brand-primary lighten-5"
            color="brand-primary"
            icon
            @click="onAffixClick('next')"
          >
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-col>

    <v-col cols="12">
      <v-slide-group
        ref="categoriesSlideGroup"
        class="categories-slider-group"
        show-arrows="always"
      >
        <v-slide-item
          v-for="(store, idx) in stores"
          :key="`category-${idx}`"
        >
          <div
            :style="`width: ${cardWidth}px;`"
            class="ml-1 mr-5 mb-1"
          >
            <category-card
              :item="store.Category"
              :to="{name: 'Store', params: {slug: store.Slug, id: store.Id}}"
              hover
            />
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-col>
  </v-row>
</template>

<script>
import CategorySliderMixin from '@/theme/default/views/home/CategorySlider.js'

export default {
  name    : 'CategorySlider',
  mixins  : [CategorySliderMixin],
  computed: {
    props: {
      type   : Array,
      default: () => []
    }
  }
}
</script>

<style scoped src="@/theme/default/views/home/CategorySlider.css"></style>
<style scoped>
</style>
